import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IQuestion } from '@verzekeringapp-mono/shared/src/models/question'

interface IProps {
  question: IQuestion
}

const QuestionToggle: React.FC<IProps> = props => {
  const [showMoreInfo, setShowMoreInfo] = useState(false)
  const { question } = props

  return (
    <div className='mb-4 rounded bg-surface-card text-text-primary'>
      <div
        key={props.question.id}
        className='flex flex-row justify-between items-center px-4 cursor-pointer py-4'
        onClick={() => setShowMoreInfo(!showMoreInfo)}
      >
        <p className='font-bold'>{question.question}</p>

        <button
          type='button'
          className='flex h-[34px] w-[34px] items-center justify-center rounded-[17px] bg-surface-brand-subtle text-icon-brand'
        >
          {showMoreInfo
            ? (
              <FontAwesomeIcon
                icon={['far', 'minus']}
                size='lg'
                className='text-icon-brand'
                aria-label={'sluit het antwoord'}
              />
            )
            : (
              <FontAwesomeIcon
                icon='plus'
                size='lg'
                className='text-icon-brand'
                aria-label={'bekijk het antwoord'}
              />
            )}
        </button>
      </div>

      {showMoreInfo && (
        <div className='rounded-b border-t border-border-default bg-surface-card p-4'>
          <div
            className='html-content p-4'
            dangerouslySetInnerHTML={{ __html: question.answer }}
          />
        </div>
      )}
    </div>
  )
}

export default QuestionToggle
